{
  "title": "System Status",
  "voice_install": {
    "title": "Install Voice Interface",
    "lxc_hint": "Runs as incus-LXC (no Docker)",
    "download_hint": "Models/voices will be downloaded (~0.5–1 GB)",
    "ports_hint": "STT on port 10300, TTS (Piper) on port 10200",
    "autostart_hint": "Containers start automatically on every system reboot",
    "log_title": "Installation log",
    "log_empty": "Waiting for log output…",
    "running": "Installation running — incus container + models being set up…",
    "starting": "Starting installation…",
    "done_msg": "Voice interface installed successfully — STT port 10300 · TTS port 10200",
    "failed": "Installation failed",
    "unknown_error": "Unknown error",
    "cancel": "Cancel",
    "install": "Install"
  },
  "subtitle": "Auto-refresh every {{seconds}}s",
  "subtitle_with_uptime": "Auto-refresh every {{seconds}}s · running for {{uptime}}",
  "stats": {
    "agents": "Agents",
    "agents_detail": "{{count}} {{type}}",
    "projects": "Projects",
    "projects_detail": "{{count}} active",
    "sessions": "Sessions",
    "sessions_detail": "{{count}} active",
    "messages": "Messages",
    "messages_detail": "{{count}} compactions",
    "tool_calls": "Tool calls",
    "tool_calls_detail": "{{rate}}% success",
    "db_size": "DB size",
    "db_size_detail": "sessions.db",
    "python": "Python",
    "version": "Version",
    "version_detail": "HydraHive"
  },
  "paths": {
    "title": "Paths",
    "data": "Data",
    "config": "Config",
    "db": "DB"
  },
  "checks": {
    "db": "DB",
    "db_ok": "readable/writable",
    "llm": "LLM",
    "llm_no_config": "No config",
    "llm_no_model": "No default model",
    "llm_no_provider": "No providers",
    "llm_ok": "{{model}} · {{count}} provider(s)",
    "workspaces": "Workspaces",
    "workspaces_missing": "Directory missing",
    "disk": "Disk",
    "disk_detail": "{{free_gb}} GB free ({{free_pct}}%)"
  },
  "uptime": {
    "seconds": "{{n}}s",
    "minutes": "{{m}}m {{s}}s",
    "hours": "{{h}}h {{m}}m",
    "days": "{{d}}d {{h}}h"
  },
  "agentlink": {
    "title": "AgentLink",
    "not_configured": "AgentLink not configured",
    "not_configured_hint": "Set HH_AGENTLINK_URL so ask_agent can route between agents.",
    "connected": "connected",
    "disconnected": "disconnected",
    "url": "REST",
    "ws": "WebSocket",
    "agent_id": "Agent ID",
    "timeout": "Handoff timeout",
    "known_agents": "Known agents ({{count}})",
    "states": "states",
    "last_connect": "Last connect",
    "reconnects": "Reconnects",
    "pending": "Pending handoffs",
    "open_dashboard": "Open dashboard",
    "reconnect": "Connect"
  },
  "minimax": {
    "title": "MiniMax token quota",
    "no_data": "No quota data available.",
    "reset_in": "reset in {{time}}",
    "weekly": "weekly: {{used}} / {{total}} ({{pct}}%)",
    "error_invalid_api_key": "API key invalid",
    "error_network_error": "Network error",
    "error_invalid_json": "Could not parse response",
    "error_upstream_error": "MiniMax server error"
  },
  "backup": {
    "title": "System Backup",
    "description": "Full backup of database, configs and user workspaces. For catastrophe recovery and server migration.",
    "download": "Download Backup",
    "restore": "Restore Backup",
    "restore_title": "Restore system?",
    "restore_warning": "File: {{file}}. Current state will be auto-saved as rollback. Service will restart after restore.",
    "uploading": "Uploading backup and validating integrity…",
    "waiting_restart": "Restore applied — waiting for service restart…",
    "restore_done": "Restore complete. Please log in again.",
    "restore_failed": "Restore failed.",
    "cancel": "Cancel",
    "confirm_restore": "Restore",
    "close": "Close"
  },
  "migration": {
    "title": "Server Migration (Full Clone)",
    "description": "Transfers ALL data via rsync to a freshly installed HydraHive2 server — including projects, Git repos, workspaces, VMs and disk archives. Incremental and resumable.",
    "open": "Clone server",
    "running_short": "Migration running…",
    "warning": "The target server must have a freshly installed HydraHive2. ALL data there will be overwritten with this server's data. The target service is stopped during transfer and restarted afterwards.",
    "host": "Target host / IP",
    "port": "SSH port",
    "user": "SSH user",
    "password": "SSH password",
    "bwlimit": "Bandwidth limit (KB/s, 0 = unlimited)",
    "start": "Start clone",
    "cancel": "Cancel",
    "close": "Close",
    "running": "Transfer in progress — this may take hours for large data sets…",
    "success": "Migration completed successfully. The target server is a 1:1 clone.",
    "failure": "Migration failed — see log.",
    "log_wait": "Waiting for output…",
    "err": {
      "migration_already_running": "A migration is already running.",
      "migration_invalid_host": "Invalid target host.",
      "migration_invalid_user": "Invalid SSH user."
    }
  },
  "tailscale": {
    "title": "Tailscale",
    "not_installed": "Tailscale is not installed.",
    "install_hint": "Installs the Tailscale binary and enables tailscaled. Connect here afterwards with an auth key.",
    "install_button": "Install Tailscale",
    "installing": "Installing…",
    "install_failed": "Installation failed",
    "install_success": "Tailscale installed.",
    "connected": "Connected",
    "disconnected": "Not connected",
    "hostname": "Hostname",
    "dns": "DNS name",
    "connect": "Connect",
    "logout": "Log out",
    "copy_ip": "Copy IP",
    "copied": "Copied!",
    "admin_console": "Admin console",
    "authkey_hint": "Create an auth key in the Tailscale admin panel:",
    "authkey_placeholder": "tskey-auth-...",
    "error_connect": "Connection failed",
    "error_logout": "Logout failed",
    "version": "Version",
    "exit_node": "Exit node",
    "peers": "Peers in tailnet ({{count}})",
    "invite_title": "Invite new node",
    "invite_explainer": "Generates a one-time auth key (valid 24h) for another server. Requires a Tailscale admin API key configured below.",
    "invite_button": "Generate auth key",
    "invite_generating": "Generating…",
    "invite_failed": "Auth key could not be generated",
    "invite_copy": "Copy",
    "invite_copied": "Copied!",
    "invite_expires_at": "Valid until {{when}}",
    "admin_settings_toggle": "API key settings",
    "admin_api_key_label": "Tailscale API key",
    "admin_api_key_placeholder": "tskey-api-...",
    "admin_api_key_hint": "From the Tailscale admin panel → Settings → Keys → API access tokens.",
    "admin_tailnet_label": "Tailnet",
    "admin_tailnet_hint": "'-' uses your own tailnet. Otherwise the tailnet name (e.g. example.com).",
    "admin_save": "Save",
    "admin_saving": "Validating…",
    "admin_save_failed": "API key was rejected by Tailscale",
    "admin_configured": "API key configured",
    "admin_not_configured": "No API key configured"
  },
  "samba": {
    "title": "SMB Shares (Samba)",
    "subtitle": "Project workspaces as network shares — mountable from Windows/Mac/Linux.",
    "not_installed": "not set up",
    "running": "running",
    "setup": "Set up Samba",
    "running_setup": "Setting up Samba…",
    "done": "Samba running. Enable per-project via the project's settings tab.",
    "failed": "Samba setup failed",
    "timeout": "Setup timed out — check log",
    "user": "Login",
    "password": "Password",
    "copy": "Copy",
    "copied": "Copied!"
  },
  "bridge": {
    "title": "Network bridge (br0)",
    "subtitle": "Bridged networking for VMs and containers — same IP range as the host.",
    "not_installed": "not set up",
    "setup": "Set up bridge",
    "confirm_question": "Set up bridge now?",
    "confirm_hint": "Setup changes the netplan config and runs `netplan apply` — network may drop for ~10 seconds. SSH sessions might hang but recover.",
    "confirm_button": "Set up now",
    "running": "Setting up bridge…",
    "done": "Bridge set up — VMs/containers now have LAN access.",
    "failed": "Bridge setup failed",
    "timeout": "Setup timed out — check log",
    "log_empty": "No output yet…"
  },
  "settings": {
    "title": "Settings",
    "subtitle": "Integration settings without SSH. The SearXNG URL takes effect immediately; integrations like Mail/Discord/AgentLink require a backend restart.",
    "gear_tooltip": "Settings"
  },
  "local_media": {
    "title": "Local image/video generation",
    "subtitle": "ComfyUI on your own NVIDIA GPU: images (SDXL) and videos (Wan 2.1) without cloud costs.",
    "installed": "installed",
    "not_installed": "not installed",
    "gpu": "GPU: {{name}} · {{vram}} GB VRAM",
    "gpu_none": "No NVIDIA GPU detected",
    "install": "Install ({{size}} download)",
    "uninstall": "Remove",
    "blocked_title": "Not possible on this hardware",
    "blocked": {
      "no_gpu": "Blocked: no NVIDIA GPU found.",
      "vram_too_small": "Blocked: the GPU does not have enough VRAM. At least {{min}} GB are required.",
      "disk_too_small": "Blocked: not enough free disk space ({{free}} free, {{need}} required)."
    },
    "confirm_install": "Install now? About {{size}} of models will be downloaded ({{free}} free).",
    "confirm_install_hint": "Depending on your connection this can take an hour or more. HydraHive stays usable meanwhile.",
    "confirm_install_button": "Install now",
    "confirm_uninstall": "Really remove local image/video generation?",
    "confirm_uninstall_hint": "Container, models (~{{size}}) and the “Local GPU” backend are deleted. Default models pointing to it are reset. Docker itself stays.",
    "confirm_uninstall_button": "Remove permanently",
    "running_install": "Installing… the log follows along.",
    "running_uninstall": "Removing…",
    "done_install": "Installed. The local models are now available for image and video.",
    "done_uninstall": "Removed. Updates will not reinstall it.",
    "failed": "Failed — see log for details",
    "log_empty": "Waiting for start (up to 5 seconds)…"
  }
}
